<template>
	<div id="StepWizardThemes" class="text-left">
		<div class v-if="!showIframePreview">
			<h4>{{ stepName }}</h4>
		</div>
		<div class="input-area">
			<div class="row" :class="selectedLayout.id != null ? 'd-none' : ''">
				<div
					v-for="(layout, index) in layouts"
					:key="layout.id"
					class="col-12 col-md-6 text-center mb-5"
				>
					<img
						@click="handleLayout(layout)"
						:src="layout.thumbnail"
						:alt="`Template-${index}`"
						class="layout-thumbnail img-fluid"
					/>
				</div>
			</div>
			<transition name="slide">
				<div class="iframe-layout" v-if="showIframePreview">
					<div class="iframe-view" :class="fremeModeActive">
						<div class="iframe">
							<iframe
								:src="selectedLayout.url"
								frameborder="0"
								allowfullscreen
							></iframe>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "StepWizardThemes",
		props: {
			stepName: {
				type: String,
				required: false,
			},
		},
		mounted(){
			this.$emit("updateStep");
		},
		methods: {
			handleLayout(layout) {
				this.$store.dispatch("WIZARD_TOGGLE_LAYOUT_PREVIEW");
				this.$store.dispatch("WIZARD_SELECT_LAYOUT", [layout]);
  				document.documentElement.scrollTop = 0;
				document.body.scrollTop = 0; // For Safari
			},
			async getTemplates() {
				let layoutList = await this.loadLayouts();
				this.$store.dispatch("WIZARD_POPULATE_LAYOUTS", [layoutList]);
			},
			loadLayouts() {
				return new Promise((resolve) => {
					let token = this.$session.get("jwt");
					axios({
						method: "get",
						url: `${process.env.ROOT_API}api/template`,
						data: "",
						headers: {
							Authorization: "Bearer " + token,
						},
					}).then((response) => {
						resolve(response.data.content);
					});
				});
			},
		},
		computed: {
			showIframePreview() {
				return this.$store.state.wizard.layout.layoutPreview;
			},
			fremeModeActive() {
				return this.$store.state.wizard.layout.iframeMode;
			},
			selectedLayout() {
				return this.$store.state.wizard.dataSite.layout;
			},
			layouts() {
				return this.$store.state.wizard.layout.layoutList;
			},
		},
		created() {
			this.getTemplates();
		},
		mounted() {
			this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [false]);
		},
	};
</script>

<style scoped>
	.no-overflow {
		overflow-y: hidden;
	}
	.iframe-view {
		display: block;
		margin-top: 0;
		margin-left: 0;
		width: 100%;
		height: auto;
	}
	.iframe {
		display: flex;
		justify-content: center;
		align-items: center;
		background-image: url("../../../src/assets/loading/Uli-loading.gif") !important ;
		background-repeat: no-repeat !important;
    	background-position: center center !important;
		background-size: 90px 90px;
	}
	.desktop .iframe {
		width: 100%;
		display: block;
		position: relative;
		width: 400%;
		height: auto;
		margin-bottom: 4rem;
		overflow: hidden;
		border-radius: 6px;
		margin-bottom: calc(-170% + 0.85rem);
		-ms-transform: scale(0.25);
		-moz-transform: scale(0.25);
		-o-transform: scale(0.25);
		-webkit-transform: scale(0.25);
		transform: scale(0.25);
		-ms-transform-origin: 0 0;
		-moz-transform-origin: 0 0;
		-o-transform-origin: 0 0;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
	}
	.desktop .iframe:before {
		content: "";
		display: block;
		width: 100%;
		padding-top: 60%;
	}
	.desktop iframe {
		top: 0;
		position: absolute;
		width: 100%;
		height: 100%;
	}
	.mobile .iframe iframe {
		width: 100%;
		top: 0;
		left: auto;
		margin-bottom: 2rem;
		-ms-transform: scale(1);
		-moz-transform: scale(1);
		-o-transform: scale(1);
		-webkit-transform: scale(1);
		transform: scale(1);
		height: 470px;
	}
	.slide-enter-active,
	.slide-leave-active {
		transition: top 0.8s ease;
	}
	.slide-enter, .slide-leave-active /* .fade-leave-active below version 2.1.8 */ {
		top: 5000px;
	}
	@media all and (min-width: 992px) {
		.iframe-view {
			height: 624px;
		}
		.mobile .iframe {
			margin: 0 auto;
			width: 360px;
		}
		.mobile .iframe iframe {
			height: 570px;
		}
		.desktop .iframe {
			width: 125%;
			display: block;
			position: relative;
			height: auto;
			margin-bottom: 4rem;
			overflow: hidden;
			border-radius: 6px;
			margin-bottom: calc(-170% + 0.85rem);
			-ms-transform: scale(0.8);
			-moz-transform: scale(0.8);
			-o-transform: scale(0.8);
			-webkit-transform: scale(0.8);
			transform: scale(0.8);
			-ms-transform-origin: 0 0;
			-moz-transform-origin: 0 0;
			-o-transform-origin: 0 0;
			-webkit-transform-origin: 0 0;
			transform-origin: 0 0;
			
		}
	}

	.layout-thumbnail {
		transform: scale(0.95);
		transition: all 200ms ease;
		cursor: pointer;
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
		 
	}
	.layout-thumbnail:hover {
		transform: scale(1);
		box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.16);
	}
</style>


// WEBPACK FOOTER //
// src/components/organisms/StepWizardThemes.vue